import { GlProgressBar, GlLink, GlButton, GlTooltipDirective } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { __, n__, sprintf } from '~/locale';
import initIssuablePopovers from '../../issuable/popover/index.js?vue3';
import { MAX_MILESTONES_TO_DISPLAY } from '../constants';
import IssuableStats from './issuable_stats.vue?vue3';
export default {
    name: 'ReleaseBlockMilestoneInfo',
    components: {
        GlProgressBar,
        GlLink,
        GlButton,
        IssuableStats
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        milestones: {
            type: Array,
            required: true
        },
        openedIssuesPath: {
            type: String,
            required: false,
            default: ''
        },
        closedIssuesPath: {
            type: String,
            required: false,
            default: ''
        },
        openedMergeRequestsPath: {
            type: String,
            required: false,
            default: ''
        },
        mergedMergeRequestsPath: {
            type: String,
            required: false,
            default: ''
        },
        closedMergeRequestsPath: {
            type: String,
            required: false,
            default: ''
        },
        showDetails: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data () {
        return {
            showAllMilestones: false
        };
    },
    computed: {
        percentCompleteText () {
            return sprintf(__('%{percent}%{percentSymbol} complete'), {
                percent: this.percentComplete,
                percentSymbol: '%'
            });
        },
        percentComplete () {
            const percent = Math.round(this.issueCounts.closed / this.issueCounts.total * 100);
            return Number.isNaN(percent) ? 0 : percent;
        },
        issueCounts () {
            return this.milestones.map((m)=>m.issueStats || {}).reduce((acc, current)=>{
                acc.total += current.total || 0;
                acc.closed += current.closed || 0;
                return acc;
            }, {
                total: 0,
                closed: 0
            });
        },
        showMergeRequestStats () {
            return this.milestones.some((m)=>m.mrStats);
        },
        mergeRequestCounts () {
            return this.milestones.map((m)=>m.mrStats || {}).reduce((acc, current)=>{
                acc.total += current.total || 0;
                acc.merged += current.merged || 0;
                acc.closed += current.closed || 0;
                return acc;
            }, {
                total: 0,
                merged: 0,
                closed: 0
            });
        },
        milestoneLabelText () {
            return n__('Milestone', 'Milestones', this.milestones.length);
        },
        milestonesToDisplay () {
            return this.showAllMilestones ? this.milestones : this.milestones.slice(0, MAX_MILESTONES_TO_DISPLAY);
        },
        showMoreLink () {
            return this.milestones.length > MAX_MILESTONES_TO_DISPLAY;
        },
        moreText () {
            return this.showAllMilestones ? __('show fewer') : sprintf(__('show %{count} more'), {
                count: this.milestones.length - MAX_MILESTONES_TO_DISPLAY
            });
        }
    },
    watch: {
        showAllMilestones () {
            this.$nextTick(()=>this.initMilestonePopovers());
        }
    },
    mounted () {
        this.initMilestonePopovers();
    },
    methods: {
        initMilestonePopovers () {
            const links = this.$el.querySelectorAll('[data-reference-type="milestone"]');
            initIssuablePopovers(Array.from(links));
        },
        toggleShowAll () {
            this.showAllMilestones = !this.showAllMilestones;
        },
        shouldRenderBullet (milestoneIndex) {
            return Boolean(milestoneIndex !== this.milestonesToDisplay.length - 1 || this.showMoreLink);
        },
        shouldRenderShowMoreLink (milestoneIndex) {
            return Boolean(milestoneIndex === this.milestonesToDisplay.length - 1 && this.showMoreLink);
        }
    }
};
